import {
  createAsyncAction,
  createSyncAction,
} from "../../utils/actionCreators";

export const types = {
  PROCESSAR: "@@export-sla/PROCESSAR",
  CLEAN_FILE: "@@export-sla/CLEAN_FILE",
};

export const actions = {
  processar: createAsyncAction(types.PROCESSAR),
  cleanFile: createSyncAction(types.CLEAN_FILE),
};
